
finishCampaign();
function finishCampaign() {

    var present = document.getElementById('present');
    var buttons = present.getElementsByClassName('kirinlemon-button');
    var button = Array.prototype.slice.call(buttons)[0];

    var now = new Date();
    var limit = new Date(2019, 5, 1, 0, 0);
    if (now.getTime() > limit.getTime()) {
        button.innerHTML = 'キャンペーンは終了いたしました';
        button.style.background = 'none';
        button.style.backgroundColor = '#ffe900';
        button.style.padding = '7px';
    }

}

window.addEventListener('load', function () {
    var agent = navigator.userAgent;
    if (agent.search(/iPhone/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1) {
        var adjusts = document.getElementsByClassName('changeHeight');
        var adjust = Array.prototype.slice.call(adjusts);

        adjust.forEach(function (value) {
            var bgs = value.getElementsByClassName('bgTexture');
            var bg = Array.prototype.slice.call(bgs)[0];
            var bgheight = value.clientHeight;
            bg.style.height = bgheight - 70 + 'px';

        });
    }
});


setAnimation();
function setAnimation() {

    var mv = document.getElementById('mainvisual');
    var topBg = document.getElementById('top_bg');

    var circles = topBg.getElementsByClassName('circle');
    var circle = Array.prototype.slice.call(circles)[0];
    var eachcir = Array.prototype.slice.call(circle.children);

    var triangles = topBg.getElementsByClassName('triangle');
    var triangle = Array.prototype.slice.call(triangles)[0];
    var eachtri = Array.prototype.slice.call(triangle.children);

    var rectangles = topBg.getElementsByClassName('rectangle');
    var rectangle = Array.prototype.slice.call(rectangles)[0];
    var eachrect = Array.prototype.slice.call(rectangle.children);


    var top = document.getElementById('top');

    var topTitles = top.getElementsByClassName('kirinlemon-totle');
    var topTitle = Array.prototype.slice.call(topTitles)[0];

    var topTexts = top.getElementsByTagName('p');
    var topTextPc = Array.prototype.slice.call(topTexts)[0];
    var topTextSp = Array.prototype.slice.call(topTexts)[1];

    var lead = document.getElementById('lead');

    var about = document.getElementById('about');

    var present = document.getElementById('present');

    var picAreas = document.getElementsByClassName('pic_area');
    var picArea = Array.prototype.slice.call(picAreas);
    var picText = [];
    var pict = [];

    picArea.forEach(function (value) {

        var picletters = value.getElementsByClassName('pic_txt');
        var picletter = Array.prototype.slice.call(picletters)[0];
        if (picletter != undefined) {
            picText.push(picletter);
        }


        var picpics = value.getElementsByClassName('pic');
        var picpic = Array.prototype.slice.call(picpics)[0];
        if (picpic != undefined) {
            pict.push(picpic);
        }

    });


    var bgUnits = document.getElementsByClassName('bgTexture');
    var bgUnit = Array.prototype.slice.call(bgUnits);
    bgUnit.push(present);


    readyAnimation();

    window.addEventListener('load', function () {
        triggerAnimation();
    });


    function readyAnimation() {

        init(mv);
        init(topTitle);
        init(topTextPc);
        init(topTextSp);

        picText.forEach(function (value) {
            init(value);
        });
        pict.forEach(function (value) {
            init(value, 'special');
        });
        bgUnit.forEach(function (value) {
            init(value);
        });

        eachcir.forEach(function (value) {
            init(value);
        });
        eachrect.forEach(function (value) {
            init(value);
        });
        eachtri.forEach(function (value) {
            init(value);
        });

        function init(c, s) {
            if (s == "specials") {
                c.style.overflow = 'hidden';
                c.style.transition = '0.8s';
                c.style.height = "0";
                var cc = Array.prototype.slice.call(c.children)[0];
                cc.style.opacity = '0';
                cc.style.transition = '0.5s';
                cc.style.transform = 'translateY(' + 50 + 'px)';
            } else {
                c.style.opacity = '0';
                c.style.transition = '0.6s';
                c.style.transform = 'translateY(' + 50 + 'px)';
            }
        }

    }


    function triggerAnimation() {

        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        picText.forEach(function (value) {
            var rect = value.getBoundingClientRect();
            var rectTop = parseInt(rect.top + scrollTop);
            value.setAttribute('rectTop', rectTop);
            scrollAnimation(value, scrollTop);
        });
        pict.forEach(function (value) {
            var rect = value.getBoundingClientRect();
            var rectTop = parseInt(rect.top + scrollTop);
            value.setAttribute('rectTop', rectTop);
            scrollAnimation(value, scrollTop, 'special');
        });
        bgUnit.forEach(function (value) {
            var rect = value.getBoundingClientRect();
            var rectTop = parseInt(rect.top + scrollTop);
            value.setAttribute('rectTop', rectTop);
            scrollAnimation(value, scrollTop);
        });


        eachcir.forEach(function (value, i) {
            startAnimation(value, i);
        });
        eachrect.forEach(function (value, i) {
            var index = i / 5;
            startAnimation(value, index);
        });
        eachtri.forEach(function (value, i) {
            startAnimation(value, i);
        });


        setTimeout(function () {
            startAnimation(mv);
            startAnimation(topTitle);
            startAnimation(topTextPc);
            startAnimation(topTextSp);
        }, 200);


        window.addEventListener('scroll', function () {

            var scroll = document.documentElement.scrollTop || document.body.scrollTop;

            picText.forEach(function (value) {
                setTimeout(function () {
                    scrollAnimation(value, scroll);
                }, 800);
            });
            pict.forEach(function (value) {
                scrollAnimation(value, scroll, 'special');
            });
            bgUnit.forEach(function (value) {
                scrollAnimation(value, scroll);
            });

        });


        function scrollAnimation(unit, scroll, s) {
            var height = parseInt(window.innerHeight);
            var line = parseInt(unit.getAttribute('rectTop'));
            if (scroll > line - height / 1.2) {
                startAnimation(unit, s);
            }
        }


        function startAnimation(s, ss) {
            if (ss == 'specials') {
                var cc = Array.prototype.slice.call(s.children)[0];

                setTimeout(function () {
                    s.style.height = cc.clientHeight + 'px';
                }, 300);
                setTimeout(function () {
                    cc.style.opacity = '1';
                    cc.style.transform = 'translateY(' + 0 + 'px)';
                    s.style.height = cc.clientHeight + 'px';
                }, 600);
                setTimeout(function () {
                    cc.style.overflow = 'unset';

                }, 700);
            } else if (ss != undefined) {
                setTimeout(function () {
                    var delay = ss * 150;
                    setTimeout(function () {
                        s.style.opacity = '1';
                        s.style.transform = 'translateY(' + 0 + 'px)';
                    }, delay);
                }, 500);
            } else {
                s.style.opacity = '1';
                s.style.transform = 'translateY(' + 0 + 'px)';
            }
        }


    }


}
